import { castToInteger } from "../utils/cast-to-integer";
import { getDefinedNames } from "./debugger";
import { levenshteinEditDistance } from 'levenshtein-edit-distance';
import { castToString } from "../utils/cast-to-string";
export class DebugError {
    constructor(type, message, details, stack) {
        this.type = type;
        this.message = message;
        this.details = details;
        this.stack = stack;
        this.line = this.guessLine();
        this.title = this.type.replace(/([a-z])([A-Z])/g, '$1 $2');
        try {
            if (this['getHelpWith' + this.type]) {
                this.errorHelp = this['getHelpWith' + this.type]();
            }
        }
        catch (err) {
            console.error(err);
        }
    }
    get topVisibleFrame() {
        for (var i = this.stack.length - 1; i >= 0; i--) {
            if (this.stack[i].file === '/player/code.py') {
                return this.stack[i];
            }
        }
    }
    guessLine() {
        switch (this.type) {
            case 'SyntaxError':
                return castToInteger(this.details[1][1], 0) || undefined;
        }
        const frame = this.topVisibleFrame;
        return frame && frame.line || undefined;
    }
    getHelpWithGameError() {
        return castToString(this.details[1], "A command you issued to your Robot failed. Take a look at the error message for information.");
    }
    getHelpWithAttributeError() {
        const found = [...this.message.matchAll(/'([^']+)'/g)];
        if (found.length === 2) {
            const [object, attribute] = found.map(f => f[1]);
            return `<code>${object}</code> doesn't have anything inside it called <code>${attribute}</code>. Double check that you haven't mistyped the name, and that you are using the correct object.`;
        }
        return `Python is complaining because the object you are trying to use does not contain the function or variable you have tried to use. Check the name of the object and function or variable you are trying to access.`;
    }
    getHelpWithNameError() {
        const found = this.message.match(/'(.*)'/);
        const name = found && found.length > 1 && found[1] || undefined;
        if (name) {
            const definedNames = getDefinedNames();
            let bestMatch = undefined;
            let bestDistance = 2;
            getDefinedNames().forEach(dName => {
                const score = levenshteinEditDistance(name, dName, true);
                if (score < bestDistance) {
                    bestMatch = dName;
                    bestDistance = score;
                }
            });
            if (bestMatch) {
                return `Python doesn't recognize <code>${name}</code>. Did you mean <code>${bestMatch}</code>? Don't forget: Python is very fussy about exact spelling and capitalization.`;
            }
            return `Python doesn't recognize <code>${name}</code>. Don't forget: Python is very fussy about spelling and capitalization, so double check that you have spelled it correctly.`;
        }
        return "Python doesn't recognize a variable or function you are trying to use. Check that everything on this line is spelled correctly, and that things are capitalized correctly.";
    }
}
